function EmptyStateVoiceRecords({ searchQuery, filterType, onResetFilters, onOpenApiKeyModal, hasApiKey }) {
    try {
        return (
            <div className="text-center py-8 bg-white rounded-lg border border-gray-200" data-name="empty-state">
                <div className="text-5xl mb-4 text-gray-300">
                    <i className="fas fa-microphone-alt"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-700 mb-2">尚無語音記錄</h3>
                
                {searchQuery || filterType !== 'all' ? (
                    <div>
                        <p className="text-gray-600 mb-4">
                            找不到符合搜尋條件的語音記錄
                        </p>
                        <button 
                            onClick={onResetFilters}
                            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                            data-name="reset-filters-button"
                        >
                            <i className="fas fa-times-circle mr-2"></i>
                            清除過濾條件
                        </button>
                    </div>
                ) : (
                    <div>
                        <p className="text-gray-600 mb-4">
                            您尚未生成任何 AI 語音，請在內容頁面中使用「生成 AI 語音」功能
                        </p>
                        <div className="flex flex-col sm:flex-row gap-3 justify-center">
                            <a 
                                href="/history"
                                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                                data-name="go-to-history-button"
                            >
                                <i className="fas fa-history mr-2"></i>
                                前往轉換記錄
                            </a>
                            {!hasApiKey && (
                                <button 
                                    onClick={onOpenApiKeyModal}
                                    className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
                                    data-name="setup-api-key-button"
                                >
                                    <i className="fas fa-key mr-2"></i>
                                    設定 HeyGen API Key
                                </button>
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    } catch (error) {
        console.error('EmptyStateVoiceRecords component error:', error);
        reportError(error);
        return null;
    }
}

export default EmptyStateVoiceRecords;